import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface PageTitleProps {
  children: React.ReactNode;
}

const PageTitle = ({ children }: PageTitleProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="h5"
        component="h1"
        sx={{
          fontWeight: 500,
          pb: 1.5,
          borderBottom: "2px solid",
          borderColor: "grey.300",
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default PageTitle;
